var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5105 0.0774926C19.0241 0.106825 17.5808 0.573909 16.3668 1.41846C15.1528 2.26301 14.2239 3.44625 13.6999 4.81546C13.1724 3.43464 12.2394 2.23947 11.0197 1.38203C9.7999 0.524601 8.34851 0.0436749 6.85018 0.000450593C5.94775 -0.0098773 5.05233 0.157432 4.21654 0.492543C3.38076 0.827654 2.62147 1.3238 1.98331 1.95183C1.34515 2.57986 0.841 3.3271 0.500486 4.14962C0.159971 4.97215 -0.0100366 5.85336 0.000457859 6.74147C0.000457859 15.37 13.6999 25 13.6999 25C13.6999 25 27.3602 15.37 27.3602 6.74147C27.3603 5.85982 27.1826 4.98693 26.8374 4.17335C26.4922 3.35978 25.9864 2.6217 25.3493 2.00188C24.7122 1.38205 23.9565 0.892803 23.1259 0.562473C22.2952 0.232143 21.4063 0.0673001 20.5105 0.0774926Z",
    fill: "url(#paint0_linear_5605_2946)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5605_2946",
    x1: 13.5,
    y1: -22,
    x2: 13.6801,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.228125,
    stopColor: "#FF0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882792,
    stopColor: "#FF00D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.a6e46c46d60d533b2bd4c15cfc19a768.svg";
export { ForwardRef as ReactComponent };